import React, { useState } from 'react';
import Sidebar, { SidebarItem } from './Sidebar';
import '../App.css';
import Cookies from 'js-cookie';
import { IconButton, Avatar, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Menu, MenuItem } from '@mui/material';
import { Outlet, Link, useNavigate } from 'react-router-dom';
// import homeicon from './Assets/images/Home.png';
import homeactiveicon from './Assets/images/Home white icon.png';
// import Chaticon from './Assets/images/Group 13858.png';
import HomeIcon from './Assets/images/sideBar/HomeIcon.png'
import Appointment from './Assets/images/sideBar/AppointmentsIcon.png'
import ChatIcon from './Assets/images/sideBar/ChatIcon.png'
import PatientIcon from './Assets/images/sideBar/PatientListIcon.png'


import { useLocation } from 'react-router-dom';
import { clearTokens } from './Auth/AuthUtil.js';
import { SidebarContext } from './Sidebar';

function Home() {
    const doctorDetailsCookie = Cookies.get('Doctor_details');
    let Doctor_details = {};

    const location = useLocation();
    const navigate = useNavigate();

    const [logoutOpen, setLogoutOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (doctorDetailsCookie) {
        try {
            Doctor_details = JSON.parse(doctorDetailsCookie);
        } catch (error) {
            console.log('Error parsing Doctor_details cookie:', error);
        }
    }

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogoutClick = () => {
        setLogoutOpen(true);
        handleMenuClose();
    };
    const handleProfileClick = () => {
        handleMenuClose();
        navigate('/profile');
    };


    const handleConfirmLogout = () => {
        clearTokens();
        setLogoutOpen(false);
        navigate('/login');
    };

    // Cancel logout
    const handleCancel = () => {
        setLogoutOpen(false);
    };

    return (
        <div className="home-container flex">
            <Sidebar Doctor_details={Doctor_details}>
                {[
                    { path: '/', label: 'Home', icon: HomeIcon, activeIcon: homeactiveicon },
                    { path: '/Appointments', label: 'Appointments', icon: Appointment, activeIcon: homeactiveicon },
                    { path: '/Patientlist', label: 'Patient list', icon: PatientIcon, activeIcon: homeactiveicon },
                    { path: '/AllChat', label: 'Chat', icon: ChatIcon, activeIcon: homeactiveicon },
                ].map(({ path, label, icon, activeIcon }) => (
                    <Link to={path} key={path}>
                        <SidebarItem
                            icon={<img src={icon} alt={label} style={{ width: "2rem" }} />}
                            text={label}
                            active={location.pathname === path}
                        />
                    </Link>
                ))}
            </Sidebar>
            <div className="home-content flex-1">
                <nav className='home-content-nav flex flex-row p-2 mb-5'>
                    <div className="flex-1">
                        <p>Hello, {Doctor_details?.name}</p>
                    </div>
                    <div className="flex items-center space-x-3">
                        <IconButton onClick={handleMenuClick}>
                            <Avatar
                                alt="Doctor"
                                src={Doctor_details?.img || '/default-avatar.png'}
                                sx={{
                                    padding: "2px", // Space inside the border
                                    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" // Drop shadow
                                }}
                            />
                        </IconButton>
                    </div>

                </nav>

                <div className='box-border h-full'>
                    <Outlet />
                </div>
            </div>

            {/* Dropdown Menu */}
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleProfileClick}>Profile</MenuItem>

                <MenuItem onClick={handleLogoutClick}>
                    <div className="menuitem cursor-pointer flex items-center space-x-2">
                        <p>Logout</p>
                        <img src="https://aiwellassets.s3.ap-south-1.amazonaws.com/log+out+icon.png" alt="Logout Icon" />
                    </div>
                </MenuItem>
            </Menu>

            {/* Logout Confirmation Dialog */}
            <Dialog open={logoutOpen} onClose={handleCancel}>
                <DialogTitle>Confirm Logout</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to log out?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="primary">No</Button>
                    <Button onClick={handleConfirmLogout} color="error" autoFocus>Yes, Logout</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Home;